import { useMutation } from '@tanstack/react-query';
import dataService from 'services/dataService';
import { downloadPDF } from 'utils';

interface Props {
  patientGuid: string;
}

const getUrl = (patientGuid: string) =>
  `admins/admin-panel/patients/${patientGuid}/apcm-consent`;

export const useApcmConsentFormReport = ({ patientGuid }: Props) => {
  const { mutate, isLoading } = useMutation({
    mutationKey: ['apcmConsentFormReport'],
    mutationFn: async () => {
      const { error, data } = await dataService.getOnly(getUrl(patientGuid));

      if (error) {
        throw new Error(error);
      }

      const reportName = `apcm-consent-form-${patientGuid}.pdf`;
      downloadPDF(data, reportName);

      return data;
    },
  });

  return { getApcmConsentFormReport: mutate, isLoading };
};
